import React from 'react';
import { connect } from 'react-redux';
import {
    NavLink,
    Redirect,
    Route,
    Switch
} from 'react-router-dom';

import Icon from './../components/Icon';
import HelpTabGuides from './../components/HelpTabGuides';

import { helpSetSearch } from './../store/help/actions';

const HelpGuidesPage = props => {
    const { match, guidesCats, searchValue, setSearch, clearSearch } = props;

    return (
        <div className="container">
            <div className="container-border row help-container">
                <aside className="left-sidebar content-item">
                    <div className="search-wrap">
                        <Icon className="svg-icon" iconName="search" />
                        <input className="input-text" name="searchValue" type="text" placeholder="Search for answers" onChange={setSearch} value={searchValue} />
                        <button className="btn btn-close" type="button" onClick={clearSearch}><Icon className="svg-icon" iconName="close" /></button>
                    </div>

                    <ul className="nav-left">
                        {guidesCats.map(cat =>
                            <li key={cat.id}>
                                <NavLink onClick={searchValue ? clearSearch : null} to={`${match.url}/` + cat.id}>{cat.text}</NavLink>
                            </li>
                        )}
                    </ul>

                </aside>

                <section className="right-content padding-content">

                    <Switch>
                        <Route path={`${match.url}/:category`} component={HelpTabGuides} />
                        <Redirect from={match.url} exact to={{ pathname: `${match.url}/${guidesCats[0].id}`, search: window.location.search }} />
                    </Switch>

                </section>

            </div>

        </div>
    );
};

const mapStateToProps = state => {
    const guidesCats = Object.values(state.help.guidesCats);
    const searchValue = state.help.search;
    return { guidesCats, searchValue };
};

const mapDispatchToProps = dispatch => {
    return {
        setSearch: event => dispatch(helpSetSearch(event.target.value)),
        clearSearch: () => dispatch(helpSetSearch(''))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpGuidesPage);


// WEBPACK FOOTER //
// ./src/pages/HelpGuidesPage.js